/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { PointSource } from "components/Tasks/SelectPointPanel";
import { ReactComponent as PointIcon } from "assets/point_icon.svg";
import { FC, useState } from "react";
import { useTaskRegisterDataContext } from "context/TaskRegisterDataProvider";

interface NodeSelectorProps {
  label?: string;
  nodeId?: number;
  disabled?: boolean;
  onSelected?: (point: PointSource) => void;
}
export const NodeSelector: FC<NodeSelectorProps> = ({
  label,
  nodeId,
  disabled,
  onSelected,
}) => {
  const { pointNodes } = useTaskRegisterDataContext();
  const [selectedNodeId, setSelectedNodeId] = useState(nodeId);
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select
        sx={{ width: "100%", backgroundColor: "white" }}
        size="small"
        label={label}
        value={selectedNodeId?.toString() ?? ""}
        onChange={(e) => {
          const selectedNodeId = Number(e.target.value);
          setSelectedNodeId(selectedNodeId);
          // const { value } = e.target;
          const selectedPoint = pointNodes.find(
            (point) => point.nodeId === selectedNodeId
          );
          if (selectedPoint !== undefined) {
            onSelected?.(selectedPoint);
          }
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
        disabled={disabled}
      >
        {pointNodes.map((point: PointSource) => (
          <MenuItem key={point.key} value={point.nodeId}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <PointIcon />
              </Grid>
              <Grid item xs={3}>
                {point.label}
              </Grid>
            </Grid>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
